import { TFunction } from 'i18next';

export enum ProjectRole {
  CLIENT = 'client',
  CONTRACTOR = 'contractor',
}

export const projectRoleOptions: ProjectRole[] = [
  ProjectRole.CLIENT,
  ProjectRole.CONTRACTOR,
];

export const getProjectRoleDisplay = (
  role: ProjectRole,
  t: TFunction<'shared', 'ProjectRole'>,
) => {
  return role === ProjectRole.CLIENT ? t('client') : t('contractor');
};
